import { Component, Input } from '@angular/core';

export interface HeaderButton {
  title: string;
  url?: string;
  callback?: () => void;
  icon?: string;
  tooltip?: string;
  cssClasses?: string;
  buttonId?: string;
  openNewTab?: boolean;
}

@Component({
  selector: 'app-tertiary-dropdown-button',
  templateUrl: './tertiary-dropdown-button.component.html',
  styleUrls: ['./tertiary-dropdown-button.component.css'],
})
export class TertiaryDropdownButtonComponent {
  @Input() tertiaryButtons: HeaderButton[];

  clicked(button: HeaderButton): void {
    if (!button.callback) {
      console.log(`clicked on ${button.title} but it has no callback`);
      return;
    }
    button.callback();
  }
}
